import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import renderEmbeddedEntry from 'components/nodes/EmbeddedEntry';
import { useDisclosureNumberingMap } from 'contexts/DisclosureProvider';
import type { CardHeadlineProps } from './types';
import { cn } from 'utils/styles';
import React from 'react';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export const CardHeadline = ({ cardHeadline, cardId, headlineId }: CardHeadlineProps) => {
  const disclosureNumberingMap = useDisclosureNumberingMap();

  return (
    <RichTextCopy
      copy={cardHeadline}
      {...liveUpdateAttrs(cardId, 'cardHeadline')}
      additionalOptions={{
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_, children) => (
            <div
              id={headlineId}
              className={cn('font-sans font-semibold pb-2 sm:text-heading-lg text-heading-md h-auto grow-2')}>
              {children}
            </div>
          ),
          [INLINES.EMBEDDED_ENTRY]: (node, children) =>
            renderEmbeddedEntry(node, children, cardHeadline, disclosureNumberingMap),
        },
      }}
    />
  );
};
